import React from 'react';
import { isMobile } from 'react-device-detect';

const MainContainer = (props) => {
  return (
    <div
      className={`col-lg-6 col-12 clr_v3_mainContent px-0 pb-4 d-flex justify-content-center flex-1 ${
        props.className ? props.className : ''
      }`}
      // style={`${!isMobile ? { minHeight: '100vh' } : ''}`}
      style={!isMobile ? { minHeight: '100vh' } : {}}
    >
      <div className="w-100 p-0 p-lg-4 clr_v3_mainContent__width container-maxWidth">
        {props.children}
      </div>
    </div>
  );
};

export default MainContainer;
